<template>
  <div>
    <table class="table table--striped">
      <tr class="title">
        <th>{{ $t('boxes.visitors.local') }}</th>
        <th>{{ $t('boxes.visitors.country') }}</th>
        <th>{{ $t('boxes.visitors.visits') }}</th>
        <th>{{ $t('locations.visitors_percent') }}</th>
      </tr>
      <tr class="item" v-for="location in locations" :key="location.id">
        <th>{{ location.city_name || $t('locations.not_identified') }}</th>
        <th>{{ location.country_name || $t('locations.not_identified') }}</th>
        <th>{{ location.visits }}</th>
        <th> {{ location.visitsPercentage }}% </th>
      </tr>
    </table>
    <div class="pagination-cont" v-show="numberOfPages > 1">
      <div class="pagination">
        <a class="pagination__item"
          @click="getLocationsOfPage(currentPage - 1)"
          v-show="currentPage !== 1">«</a>

        <a class="pagination__item"
          @click="getLocationsOfPage(page)"
          :class="{ 'active' : currentPage == page }"
          v-for="page in numberOfPages"
          :key="page">
          {{ page }}
        </a>

        <a class="pagination__item"
          @click="getLocationsOfPage(currentPage + 1)"
          v-show="currentPage !== numberOfPages">»</a>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    computed: mapGetters({
      locations: 'locations/locations',
      numberOfPages: 'locations/numberOfPages',
      currentPage: 'locations/currentPage',
    }),
    methods: mapActions({
      getLocationsOfPage: 'locations/getLocationsOfPage',
    }),
  };
</script>



// WEBPACK FOOTER //
// src/screens/Locations/components/List.vue